import { render } from "./Track.vue?vue&type=template&id=5048dd6a&scoped=true"
import script from "./Track.vue?vue&type=script&lang=js"
export * from "./Track.vue?vue&type=script&lang=js"

import "./Track.vue?vue&type=style&index=0&id=5048dd6a&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5048dd6a"]])

export default __exports__